import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import PremiumCostMLTC from '@components/PremiumCostMLTC';

const ContainerTop = styled.div<StyledProps>`
  height: 1px;
`;
const StickyContainer = styled.div<StyledProps>`
  position: ${props => props.isPinned ? 'fixed' : 'sticky'};
  width: ${props => props.isPinned ? '100vw' : '100%'};
  left: ${props => props.isPinned ? '50%' : '0'};
  margin-left: ${props => props.isPinned ? '-50%' : '0'};
  height: ${props => props.isOpen && props.isPinned ? '100vh' : 'auto'};
  background-color: ${props => props.isOpen && props.isPinned ? 'rgba(51, 51, 51, 0.85)' : 'unset'};
  top: 0px;
  z-index: 10;
  margin-bottom: 30px;
`
interface StyledProps {
  theme: ITheme,
  innerWidth?: number,
  isPinned?: boolean,
  isOpen?: boolean,
  height?: string;
  borderWidth?: number
}

export interface StickyBoxProps {
  theme?: ITheme,
  children?: React.ReactNode;

}

function StickyBox({ children }: StickyBoxProps) {
  const theme = useTheme();
  const [isPinned, setPinned] = useState<boolean>(false);
  const htmlRef = useRef<HTMLDivElement>(null);
  const [isExpaned, setIsExpanded] = useState<boolean>(false);
  const observer = useMemo(() => new IntersectionObserver(
    ([e]) => {
      if (e.intersectionRatio === 0 && e.boundingClientRect.bottom < 10) { // pinned
        setPinned(true);
      } else {
        if (e.intersectionRatio === 1) { // un-pinned
          setPinned(false)
        }
      }
    },
    { threshold: [0, 1] }
  ), []);

  const handleExpandChild = (event: any) => {
    setIsExpanded(event);
  }

  useEffect(() => {
    setTimeout(() => {
      if (htmlRef.current) {
        observer.observe(htmlRef.current);
      }
    }, 200);
  }, [htmlRef, observer]);
  return (
    <React.Fragment>
      <ContainerTop ref={htmlRef} theme={theme}>
      </ContainerTop>
      <StickyContainer theme={theme} isPinned={isPinned} isOpen={isExpaned}>
      {React.Children.toArray(children).map((item: any, index: number) => {
        return (item.type === PremiumCostMLTC ? (
          <PremiumCostMLTC
            key={`${index}`}
            {...item.props}
            onToggle={handleExpandChild}
          />
        ) : item);
      })}
      </StickyContainer>
    </React.Fragment>


  );
};

export default StickyBox;
